import React from 'react'
import {OutlookWrapper, OutlookLoginButton} from '@rankmi/ats-app'
import { config } from '@frontend/constants/outlook_config'
import "./Outlook.scss"


const OutlookLogin = ({appId}) => {
    return (
        <>
            {appId.length !==0 && (
            <OutlookWrapper config={{...config, appId: appId[0].data.app_id }}>
                <OutlookLoginButton className='button-outlook' text="Agendar reunión (Outlook)" />
            </OutlookWrapper>
            )}
        </>
    )
}

export default OutlookLogin